/**
 * @module app.cm
 */

import * as CD from 'app/cd/models/essette-api';
import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { I18N } from 'aurelia-i18n';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { ProviderService } from 'app/cd/services/provider-service';

@autoinject()
export class ProviderSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected providerId: string | null = null;
    protected locationId: string | null = null;
    protected provider: CD.Provider | null = null;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly providerService: ProviderService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async activate(params: { providerId: string, locationId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.providerId && !params?.locationId) { throw new Error('Missing required parameters: providerId or locationId'); }
        this.providerId = params.providerId;
        this.locationId = params.locationId;
        await this.reload();

        if(this.provider && routeConfig.navModel) {
            var title = this.i18n.tr('cd:routes.provider.summary.$title', { display: this.provider.$display });
            routeConfig.navModel.setTitle(title);
        }

    }
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        if(this.providerId || this.locationId) {
            await this.loadProvider();
        }
    }


    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadProvider(): Promise<void> {
        if(!this.providerId && !this.locationId) return;

        const includes: string[] = [
            'locations.facility'
        ];

        try {
            this.state.beginLoad();
            const response = this.locationId ?
                await this.providerService.loadProviderByLocation(this.locationId, { includeInactive: true }, includes) :
                await this.providerService.loadProvider(this.providerId!, includes);

            this.provider = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
